import Button from '@mui/material/Button';
import { Text } from 'components/Text';
import { IMAGES } from 'config/images';
import { AppLocale, getLocaleLanguage, getTrans } from 'modules/i18n';
import { deviceInfo, getUserDevice } from 'utils/device';
import {
  androidInstallationImages,
  androidInstallationInstructions,
  iosInstallationImages,
  iosInstallationInstructions,
  ZENJOB_LOGO_ALT_TEXT
} from '../constants';
import { InstallationInstructions } from './InstallationInstructions';
import { InstructionsForDesktopUser } from './InstructionsForDesktopUser';
import {
  ButtonContainer,
  LogoBox,
  RootBox,
  TextContainer,
  TitleContainer
} from './styledComponents';

export const InstallationGuide = () => {
  const localeLanguage = getLocaleLanguage();
  const { userDevice, userOS } = getUserDevice(navigator?.userAgent);
  const { device, os } = deviceInfo;

  return (
    <RootBox sx={{ pt: 10 }}>
      <LogoBox>
        <img alt={ZENJOB_LOGO_ALT_TEXT} src={IMAGES.proLogoPurple} />
      </LogoBox>
      <TitleContainer sx={{ pt: 0 }}>
        <Text variant="h4">{getTrans('appInstallPage.guide.heading')}</Text>
        <Text variant="h4">{getTrans('appInstallPage.intro.heading')}</Text>
      </TitleContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.intro.body1')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.intro.body2')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.intro.body3')}</Text>
      </TextContainer>
      <TitleContainer>
        <Text variant="h4">
          {getTrans('appInstallPage.instructions.heading')}
        </Text>
      </TitleContainer>
      {userDevice === device.MOBILE && userOS === os.IOS && (
        <InstallationInstructions
          instructions={iosInstallationInstructions()}
          images={iosInstallationImages[localeLanguage]}
        />
      )}
      {userDevice === device.MOBILE && userOS === os.ANDROID && (
        <InstallationInstructions
          instructions={androidInstallationInstructions()}
          images={androidInstallationImages[localeLanguage]}
        />
      )}
      {(userDevice === device.DESKTOP || userOS === os.OTHER_OS) && (
        <InstructionsForDesktopUser />
      )}
      <TextContainer
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Text>{getTrans('appInstallPage.instructions.note')}</Text>
      </TextContainer>
      <TitleContainer>
        <Text variant="h4">{getTrans('appInstallPage.wait.heading')}</Text>
      </TitleContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.wait.body')}</Text>
      </TextContainer>
      <TitleContainer>
        <Text variant="h4">{getTrans('appInstallPage.login.heading')}</Text>
      </TitleContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.login.body1')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.login.body2')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.login.body3')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.login.body4')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.login.body5')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>
          {getTrans('appInstallPage.login.body6.part1')}
          <strong>
            &nbsp;{getTrans('appInstallPage.login.body6.part2')}&nbsp;
          </strong>
          {getTrans('appInstallPage.login.body6.part3')}
        </Text>
      </TextContainer>
      <TitleContainer>
        <Text variant="h4">{getTrans('appInstallPage.support.heading')}</Text>
      </TitleContainer>
      <TextContainer>
        <Text>{getTrans('appInstallPage.support.body1')}</Text>
      </TextContainer>
      <TextContainer>
        <Text>
          {getTrans('appInstallPage.support.body2')}
          {localeLanguage == AppLocale.en_US && (
            <span style={{ color: 'red' }}>{' <3'}</span>
          )}
        </Text>
      </TextContainer>
      <ButtonContainer>
        <Button
          size="large"
          color="secondary"
          variant="contained"
          target="_blank"
          href={getTrans('url.helpCenter')}
          sx={{ minWidth: 252 }}
          data-testid="help-center-button"
        >
          {getTrans('appInstallPage.support.button')}
        </Button>
      </ButtonContainer>
      <TextContainer sx={{ pb: 0 }}>
        <Text>{getTrans('appInstallPage.signature1')}</Text>
        <Text>{getTrans('appInstallPage.signature2')}</Text>
      </TextContainer>
    </RootBox>
  );
};
